import linkToString from "./link";

const Renderers = {
  Link: linkToString
};

export default Renderers;
